// Osaka Group Constants

export const COMPANY_INFO = {
  name: "Osaka Group",
  tagline: "Your World, Our Expertise. Travel with Confidence Since 1993.",
  shortTagline: "Travel Management Company Since 1993",
  phone: "+91 858 997 8777",
  whatsapp: "+91 858 997 8777",
  email: "info@osakaair.com",
  website: "www.osakagroup.com",
  workingHours: "Mon–Fri 9:30 AM – 6:00 PM | Sat 9:30 AM – 3:30 PM",
};

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_optimistic-heyrovsky-4/artifacts/3yshmq21_Osaka%20Group%20Logo.png";

export const LEADERSHIP = [
  {
    name: "Dr. P.B. Boss",
    designation: "Founder & Chairman",
    image: "https://customer-assets.emergentagent.com/job_optimistic-heyrovsky-4/artifacts/ppviglw8_WhatsApp%20Image%202026-03-22%20at%203.44.58%20PM.jpeg",
    bio: "With over three decades of visionary leadership, Dr. P.B. Boss founded Osaka Group in 1993 and has since transformed it into one of India's most trusted travel management companies.",
  },
  {
    name: "Dr. Bissy Boss",
    designation: "Director",
    image: "https://customer-assets.emergentagent.com/job_optimistic-heyrovsky-4/artifacts/0thm43vn_WhatsApp%20Image%202026-03-22%20at%203.45.14%20PM.jpeg",
    bio: "Dr. Bissy Boss brings strategic insight and operational excellence to Osaka Group, overseeing key business functions and driving sustainable growth initiatives.",
  },
  {
    name: "Mr. Athul Boss",
    designation: "Director",
    image: "https://customer-assets.emergentagent.com/job_optimistic-heyrovsky-4/artifacts/uv7axy25_WhatsApp%20Image%202026-03-22%20at%203.44.58%20PM%20%281%29.jpeg",
    bio: "Mr. Athul Boss leads Osaka Group's digital transformation and innovation initiatives, bringing fresh perspectives to modernize travel solutions for the next generation.",
  },
];

export const STATISTICS = [
  { number: "33+", label: "Years of Excellence" },
  { number: "500+", label: "Years Combined Experience" },
  { number: "150+", label: "Travel Professionals" },
  { number: "27", label: "Offices Worldwide" },
  { number: "1M+", label: "Happy Travelers" },
  { number: "2", label: "IATA Accreditations" },
];

export const OFFICES = [
  {
    city: "Angamaly (Corporate HQ)",
    address: "4th Level, KSRTC, Bus Terminal Complex, Angamaly, Kerala, India 683572",
    phone: "+91 858 997 8777",
    email: "info@osakaair.com",
    isHQ: true,
  },
  { city: "Kochi", address: "Kochi, Kerala", phone: "+91 858 997 8777", email: "kochi@osakaair.com" },
  { city: "Thiruvananthapuram", address: "Thiruvananthapuram, Kerala", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Delhi NCR", address: "New Delhi", phone: "+91 858 997 8777", email: "delhi@osakaair.com" },
  { city: "Mumbai", address: "Mumbai, Maharashtra", phone: "+91 858 997 8777", email: "mumbai@osakaair.com" },
  { city: "Bengaluru", address: "Bengaluru, Karnataka", phone: "+91 858 997 8777", email: "bangalore@osakaair.com" },
  { city: "Chennai", address: "Chennai, Tamil Nadu", phone: "+91 858 997 8777", email: "chennai@osakaair.com" },
  { city: "Hyderabad", address: "Hyderabad, Telangana", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Kolkata", address: "Kolkata, West Bengal", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Pune", address: "Pune, Maharashtra", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Ahmedabad", address: "Ahmedabad, Gujarat", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Jaipur", address: "Jaipur, Rajasthan", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Lucknow", address: "Lucknow, Uttar Pradesh", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Goa", address: "Goa", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Chandigarh", address: "Chandigarh", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Coimbatore", address: "Coimbatore, Tamil Nadu", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Vizag", address: "Visakhapatnam, Andhra Pradesh", phone: "+91 858 997 8777", email: "info@osakaair.com" },
  { city: "Bhubaneswar", address: "Bhubaneswar, Odisha", phone: "+91 858 997 8777", email: "info@osakaair.com" },
];

export const INTERNATIONAL_OFFICES = [
  { country: "USA", flag: "\u{1F1FA}\u{1F1F8}", city: "Lewes, Delaware", company: "OSAKA CONNECT US INC", address: "16192 Coastal Highway, Lewes, Sussex County, DE 19956" },
  { country: "Canada", flag: "\u{1F1E8}\u{1F1E6}", city: "Toronto", company: "OSAKA CONNECT CANADA INC", address: "2482 Yonge St, 1136, Toronto, Ontario, M4P2H5" },
  { country: "United Kingdom", flag: "\u{1F1EC}\u{1F1E7}", city: "London", company: "OSAKA CONNECT UK LIMITED", address: "71-75 Shelton Street, Covent Garden, London, WC2H 9JQ" },
  { country: "Australia", flag: "\u{1F1E6}\u{1F1FA}", city: "Queensland", company: "OSAKA CONNECT AUSTRALIA PTY LTD", address: "3 Longton St, Bohle Plains QLD 4817" },
  { country: "Singapore", flag: "\u{1F1F8}\u{1F1EC}", city: "Singapore", company: "OSAKACONNECTDOTCOM PTE. LTD.", address: "34, Lorong Mydin, #10-04, Astoria Park, Singapore 416827" },
  { country: "UAE", flag: "\u{1F1E6}\u{1F1EA}", city: "Dubai", company: "OSAKACONNECTDOTCOM L.L.C.-FZ", address: "Meydan Grandstand, 6th Floor, Meydan Road, Nad Al Sheba, Dubai" },
  { country: "Japan", flag: "\u{1F1EF}\u{1F1F5}", city: "Osaka", company: "Osakaconnectdotcom GK", address: "Level 9 Edobori Center Bldg., 2-1-1 Edobori, Nishi-ku Osaka 550-0002" },
  { country: "Bulgaria", flag: "\u{1F1E7}\u{1F1EC}", city: "Sofia", company: "OSAKACONNECTDOTCOM VCC", address: "10, Stefan Karadzha str., Fl. 3-4, 1000, Sofia" },
  { country: "South Africa", flag: "\u{1F1FF}\u{1F1E6}", city: "Johannesburg", company: "OSAKACONNECTDOTCOM (PTY) LTD.", address: "Nr 5 Sturdee Avenue Suite 301, Rosebank, Johannesburg, Gauteng 2196" },
];

export const GROUP_COMPANIES = [
  {
    id: "osaka-air-travels",
    name: "Osaka Air Travels",
    tagline: "Visa, Passport & Miscellaneous Services",
    description: "Osaka Group's flagship entity specializing in visa consultation & submission for 120+ countries, passport services (new, renewal, jumbo, infant), document attestation, and miscellaneous travel documentation since 1993.",
    services: ["Visa Services", "Passport Services", "Document Attestation", "PCC & OCI"],
    color: "#0A1F3D",
  },
  {
    id: "osaka-air-pvt",
    name: "Osaka Air Travels Pvt. Ltd.",
    tagline: "IATA Accredited — Ticketing & Forex",
    description: "Holding one of Kerala's oldest IATA accreditations, this entity handles domestic & international air ticketing, group bookings, foreign exchange (buy/sell currency), travel forex cards, wire transfers, and student fund remittances.",
    services: ["Air Ticketing", "Foreign Exchange", "Forex Cards", "Wire Transfers"],
    color: "#1a365d",
  },
  {
    id: "kerala-tour-mart",
    name: "Kerala Tour Mart India Pvt.Ltd",
    tagline: "Discover God's Own Country",
    description: "Specialized inbound tourism operator showcasing the beauty of Kerala with curated experiences, houseboats, and Ayurvedic retreats.",
    services: ["Kerala Tours", "Houseboat Packages", "Ayurveda Tourism", "Eco Tourism"],
    color: "#20A39E",
  },
  {
    id: "osaka-connect",
    name: "Osaka Connect",
    tagline: "World's First Travel Hypermarket & Super App",
    description: "A revolutionary B2B travel platform and corporate services provider — the world's first travel hypermarket & travel super app offering 24+ integrated products for travel agents and enterprises worldwide.",
    services: ["B2B Travel Platform", "Corporate Travel", "White-Label Solutions", "24+ Travel Products"],
    color: "#D4AF37",
  },
  {
    id: "osaka-educare",
    name: "Osaka Educare",
    tagline: "Your Path to Global Education",
    description: "Comprehensive study abroad consultancy helping students achieve their dreams of international education with university admissions and visa support.",
    services: ["University Admissions", "Student Visa", "Test Preparation", "Education Loans", "Pre-Departure Briefing"],
    color: "#6B46C1",
  },
];

export const SERVICES = [
  {
    id: "air-ticketing-forex",
    title: "Air Ticketing & Forex",
    description: "Domestic & international flights, group bookings, and comprehensive foreign exchange services.",
    icon: "Airplane",
  },
  {
    id: "visa-passport",
    title: "Visa & Passport",
    description: "Expert visa assistance for 120+ countries with high approval rates and end-to-end support.",
    icon: "Passport",
  },
  {
    id: "tour-packages",
    title: "Tour Packages",
    description: "Handcrafted holiday experiences — domestic, international, MICE, medical & pilgrimage tours.",
    icon: "MapTrifold",
  },
  {
    id: "study-abroad",
    title: "Study Abroad",
    description: "Complete overseas education solutions from counselling to university admission & visa.",
    icon: "GraduationCap",
  },
  {
    id: "corporate-travel",
    title: "Corporate Travel",
    description: "Enterprise travel management with policy compliance, credit facilities & dedicated managers.",
    icon: "Buildings",
  },
  {
    id: "insurance",
    title: "Insurance Services",
    description: "Overseas medical, health, and travel insurance with claim filing assistance.",
    icon: "ShieldCheck",
  },
  {
    id: "attestation",
    title: "Document & Attestation",
    description: "HRD, MEA, Embassy attestation, WES, ICAS, translation & foreign courier services.",
    icon: "CurrencyCircleDollar",
  },
  {
    id: "osaka-connect",
    title: "Osaka Connect",
    description: "24+ travel products on one digital platform — B2B, B2C, white-label & more.",
    icon: "DeviceMobile",
  },
];

export const SERVICE_CATEGORIES = [
  {
    id: "air-ticketing-forex",
    title: "Air Ticketing & Foreign Exchange",
    tagline: "Your gateway to seamless flights and hassle-free currency exchange",
    icon: "Airplane",
    color: "#0A1F3D",
    image: "https://images.unsplash.com/photo-1700394474173-6428c2ea061c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxmb3JlaWduJTIwZXhjaGFuZ2UlMjBjdXJyZW5jeSUyMG5vdGVzJTIwbW9uZXklMjB0cmFuc2ZlcnxlbnwwfHx8fDE3NzQxODA1NjB8MA&ixlib=rb-4.1.0&q=85",
    services: [
      "Domestic & International Air Tickets",
      "Group Bookings & Holding Tickets",
      "Foreign Exchange — Buy/Sell Currency",
      "Travel Forex Cards",
      "Wire Transfers & Repatriation of Funds",
      "Student Fund Transfer & Abroad Fee Remittance",
    ],
  },
  {
    id: "visa-passport",
    title: "Visa & Passport Services",
    tagline: "120+ countries. High approval rates. Zero stress.",
    icon: "Passport",
    color: "#D4AF37",
    image: "https://images.pexels.com/photos/4922356/pexels-photo-4922356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    services: [
      "Global Visa Consultation & Submission (120+ countries)",
      "Schengen, UK, USA, Ireland, Australia, Canada, Middle East visas",
      "New Passport, Renewal, Jumbo, Infant/Child, Damaged Replacement",
      "Document Attestation — HRD, MEA, Embassy, WES, ICAS",
      "OCI Card & Foreign Passport Services",
      "Police Clearance Certificate (PCC)",
      "Interview Guidance & Document Preparation",
      "Visa Stamping — All Middle East Countries",
      "Pan Card Services",
    ],
  },
  {
    id: "tour-packages",
    title: "Tour Packages & Holidays",
    tagline: "From weekend getaways to once-in-a-lifetime expeditions",
    icon: "MapTrifold",
    color: "#20A39E",
    image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxsdXNoJTIwZ3JlZW4lMjBLZXJhbGElMjBiYWNrd2F0ZXJzJTIwaG91c2Vib2F0JTIwdHJvcGljYWwlMjBuYXR1cmV8ZW58MHx8fHwxNzc0MTgyODIyfDA&ixlib=rb-4.1.0&q=85",
    services: [
      "Domestic & International Holiday Packages",
      "Fixed Departures & Group Tours",
      "MICE (Meetings, Incentives, Conferences, Exhibitions)",
      "Eurail Passes",
      "Medical Tourism Packages",
      "Pilgrimage Tours",
      "Airport Transfers",
    ],
  },
  {
    id: "study-abroad",
    title: "Study Abroad / Overseas Education",
    tagline: "Your path from dream university to boarding pass",
    icon: "GraduationCap",
    color: "#6B46C1",
    image: "https://images.pexels.com/photos/6684600/pexels-photo-6684600.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    services: [
      "Personalized Counselling",
      "University & Course Selection",
      "Application & Admission Support",
      "Student Visa Processing",
      "Pre-Departure Orientation",
      "Scholarship Guidance",
    ],
  },
  {
    id: "corporate-travel",
    title: "Corporate Travel Management",
    tagline: "Enterprise-grade travel solutions with dedicated account support",
    icon: "Buildings",
    color: "#1a365d",
    services: [
      "Enterprise travel accounts with policy compliance",
      "Tri-Party Agreement for 30–45 day credit facility",
      "Preferred airline management & cost optimization",
      "Dedicated relationship manager",
    ],
  },
  {
    id: "insurance",
    title: "Insurance Services",
    tagline: "Travel with confidence — we've got you covered",
    icon: "ShieldCheck",
    color: "#0A1F3D",
    services: [
      "Overseas Medical Insurance",
      "Health Insurance",
      "Travel Insurance",
      "Insurance Claim Filing Assistance",
    ],
  },
  {
    id: "attestation",
    title: "Document & Attestation Services",
    tagline: "From attestation to translation — all your paperwork, sorted",
    icon: "FileText",
    color: "#4A5568",
    services: [
      "HRD, MEA, Embassy Attestation",
      "WES & ICAS Attestation",
      "Documents Translation",
      "Foreign Courier Services",
    ],
  },
  {
    id: "osaka-connect",
    title: "Digital Travel Platform (Osaka Connect)",
    tagline: "24+ travel products. One revolutionary platform.",
    icon: "DeviceMobile",
    color: "#D4AF37",
    services: [
      "24+ Travel Products on One Platform",
      "B2B, B2C & B2E Modules",
      "White-Label Solutions for Travel Agencies",
      "Startup Facilitation Programs",
      "Holiday Builder Tool",
      "Online Booking — Air, Bus, Rail, Hotels & More",
    ],
  },
];

export const VISA_COUNTRIES = [
  { id: "uae", name: "Dubai/UAE", flag: "🇦🇪", processingTime: "3-5 days" },
  { id: "uk", name: "United Kingdom", flag: "🇬🇧", processingTime: "15-20 days" },
  { id: "usa", name: "United States", flag: "🇺🇸", processingTime: "Varies" },
  { id: "canada", name: "Canada", flag: "🇨🇦", processingTime: "20-30 days" },
  { id: "schengen", name: "Schengen", flag: "🇪🇺", processingTime: "15-20 days" },
  { id: "ireland", name: "Ireland", flag: "🇮🇪", processingTime: "10-15 days" },
];

export const PARTNERS = {
  airlines: [
    { name: "Emirates", logo: "https://www.google.com/s2/favicons?domain=emirates.com&sz=128" },
    { name: "Air India", logo: "https://www.google.com/s2/favicons?domain=airindia.in&sz=128" },
    { name: "IndiGo", logo: "https://www.google.com/s2/favicons?domain=goindigo.in&sz=128" },
    { name: "Qatar Airways", logo: "https://www.google.com/s2/favicons?domain=qatarairways.com&sz=128" },
    { name: "Singapore Airlines", logo: "https://www.google.com/s2/favicons?domain=singaporeair.com&sz=128" },
    { name: "British Airways", logo: "https://www.google.com/s2/favicons?domain=britishairways.com&sz=128" },
    { name: "Lufthansa", logo: "https://www.google.com/s2/favicons?domain=lufthansa.com&sz=128" },
    { name: "Etihad", logo: "https://www.google.com/s2/favicons?domain=etihad.com&sz=128" },
    { name: "SpiceJet", logo: "https://www.google.com/s2/favicons?domain=spicejet.com&sz=128" },
    { name: "Air India Express", logo: "https://www.google.com/s2/favicons?domain=airindiaexpress.com&sz=128" },
  ],
  associations: [
    { name: "IATA", logo: "https://www.google.com/s2/favicons?domain=iata.org&sz=128" },
    { name: "TAAI", logo: "https://www.google.com/s2/favicons?domain=taai.in&sz=128" },
    { name: "TAFI", logo: "https://www.google.com/s2/favicons?domain=tafionline.com&sz=128" },
    { name: "Skal International", logo: "https://www.google.com/s2/favicons?domain=skal.org&sz=128" },
    { name: "PHDCCI", logo: "https://www.google.com/s2/favicons?domain=phdcci.in&sz=128" },
    { name: "Italian Chamber of Commerce", logo: "https://www.google.com/s2/favicons?domain=iiccindia.com&sz=128" },
    { name: "London Chamber of Commerce", logo: "https://www.google.com/s2/favicons?domain=londonchamber.co.uk&sz=128" },
    { name: "Japan Chamber of Commerce", logo: "https://www.google.com/s2/favicons?domain=jcci.or.jp&sz=128" },
    { name: "CII", logo: "https://www.google.com/s2/favicons?domain=cii.in&sz=128" },
    { name: "FICCI", logo: "https://www.google.com/s2/favicons?domain=ficci.in&sz=128" },
    { name: "BNI", logo: "https://www.google.com/s2/favicons?domain=bni.com&sz=128" },
    { name: "IAAI", logo: "https://www.google.com/s2/favicons?domain=iaai.in&sz=128" },
    { name: "GBTA", logo: "https://www.google.com/s2/favicons?domain=gbta.org&sz=128" },
  ],
};

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Rajesh Menon",
    location: "Kochi",
    rating: 5,
    text: "Osaka Group made our family trip to Europe absolutely seamless. From visa processing to hotel bookings, everything was handled professionally. Highly recommend their services!",
    service: "Schengen Visa & Tour Package",
  },
  {
    id: 2,
    name: "Priya Sharma",
    location: "Mumbai",
    rating: 5,
    text: "The corporate travel team at Osaka has been managing our company's travel for 5 years. Their efficiency and cost optimization have been exceptional.",
    service: "Corporate Travel Management",
  },
  {
    id: 3,
    name: "Arun Kumar",
    location: "Delhi",
    rating: 5,
    text: "Got my UK visa approved on the first attempt thanks to Osaka's expert guidance. The documentation support was thorough and professional.",
    service: "UK Visa Services",
  },
  {
    id: 4,
    name: "Meera Nair",
    location: "Bangalore",
    rating: 5,
    text: "Osaka Educare helped my son get admission to a top university in Canada. Their counseling and visa assistance were invaluable.",
    service: "Study Abroad - Canada",
  },
  {
    id: 5,
    name: "Thomas George",
    location: "Thrissur",
    rating: 5,
    text: "Been booking all my flights through Osaka Air Travels for over a decade. Consistent service, great prices, and trustworthy advice.",
    service: "Air Tickets",
  },
];

export const AWARDS = [
  {
    title: "India's Most Trusted Brand of the Year Awards 2024",
    caption: "Mr. Athul Boss, Director of Osaka Group, received the award for India's Most Trusted Brand - Fastest Emerging Travel Company in India.",
    date: "24th Feb 2024",
    venue: "WelcomHotel by ITC Hotels, Delhi",
    image: "https://www.osakaair.com/files/award_achivement/image_file/32/WhatsApp%20Image%202024-02-26%20at%2018.17.59_6401135b.jpg",
  },
  {
    title: "Best Seller Award for Singapore Airlines 2022-2023",
    caption: "Chairman Dr. P B Boss of Osaka Group proudly receives the prestigious Best Seller Award for Singapore Airlines.",
    date: "25th May 2023",
    venue: "Kerala",
    image: "https://www.osakaair.com/files/award_achivement/image_file/31/award-final.jpg",
  },
  {
    title: "Most Enterprising Business Award 2023",
    caption: "Mrs. Bissy Boss, Director of Osaka Group, honoured at Ente Samrambham Shepreneurs 3.0 - Kerala's Largest Women Enclave.",
    date: "17th Mar 2023",
    venue: "Monsoon Empress Hotel, Angamaly",
    image: "https://www.osakaair.com/files/award_achivement/image_file/29/PIC_4343.jpeg.jpg",
  },
  {
    title: "Top Seller of TATA Travel Insurance",
    caption: "Osaka Connect Dot Com was awarded the top seller of TATA Travel Insurance, Rank 6 in All India.",
    date: "15th Mar 2023",
    venue: "Tata Travel Connect Event, Goa",
    image: "https://www.osakaair.com/files/award_achivement/image_file/30/award22-01.jpg",
  },
  {
    title: "Pride of Indian Women Achievements Excellence Award 2023",
    caption: "Ms. Bissy Boss honored by Dr. APJ Abdul Kalam Institute of Business Management and Skill Development.",
    date: "8th Mar 2023",
    venue: "St. Xavier's College for Women, Aluva",
    image: "https://www.osakaair.com/files/award_achivement/image_file/28/Award.jpg",
  },
  {
    title: "FICCI - Emerging Overseas Education Consultancy Award 2022",
    caption: "FICCI 'Made in Kerala Award 2022' presented Osaka Educare the Emerging Overseas Education Consultancy Award.",
    date: "10th Dec 2022",
    venue: "Grand Hyatt, Kochi",
    image: "https://www.osakaair.com/files/award_achivement/image_file/27/Educare-AWARD_1.jpg",
  },
  {
    title: "Business Connect Award",
    caption: "Dr. P B Boss received the Business Connect Award from Dipika Chikhlia for the Best Tour Organizer.",
    date: "27th Jul 2022",
    venue: "",
    image: "https://www.osakaair.com/files/award_achivement/image_file/22/Business%20Connect%20KTM%20copy.jpg",
  },
  {
    title: "India's Emerging Company Award",
    caption: "Osaka Connect Dot Com Pvt. Ltd was awarded India's Emerging Company Award for Excellence.",
    date: "5th Jul 2022",
    venue: "",
    image: "https://www.osakaair.com/files/award_achivement/image_file/24/thai.jpg",
  },
  {
    title: "Global Business Achievements 2022",
    caption: "Dr. P. B. Boss, Founder & Chairman, received the award for Most Trusted & Dynamic Business Leader.",
    date: "30th Jun 2022",
    venue: "New Delhi",
    image: "https://www.osakaair.com/files/award_achivement/image_file/23/Global%20Business%20Achievements%202022.jpg",
  },
  {
    title: "Certificate of Excellence - Fastest Growing Industrial Excellence",
    caption: "Dr. P B Boss received Certificate of Excellence for the Fastest Growing Industrial Excellence & Business Leadership.",
    date: "26th May 2022",
    venue: "New Delhi",
    image: "https://www.osakaair.com/files/award_achivement/image_file/26/Nss%20Award.png",
  },
  {
    title: "Best Tour Organizer of the Year 2022",
    caption: "Dr. P B Boss receiving 'Sree Sankaracharya Biz-Arts Award' for the Best Business Organizers.",
    date: "9th May 2022",
    venue: "Kalady, Kerala",
    image: "https://www.osakaair.com/files/award_achivement/image_file/25/sanakara.png",
  },
  {
    title: "10 Most Trusted Overseas Education Consultants in India",
    caption: "Osaka Educare received recognition from The Corporate View under the 10 Most Trusted Overseas Education Consultants.",
    date: "29th Mar 2022",
    venue: "Ernakulam, Kerala",
    image: "https://www.osakaair.com/files/award_achivement/image_file/17/IMAGE%201.JPG",
  },
  {
    title: "Women Summit and Awards 2022",
    caption: "Ms. Bissy Boss, Director, received Women Summit & Awards 2022 from Shri. Hibi Eden.",
    date: "25th Mar 2022",
    venue: "Kochi",
    image: "https://www.osakaair.com/files/award_achivement/image_file/14/WhatsApp%20Image%202022-04-05%20at%203.38.07%20PM.jpeg",
  },
  {
    title: "National Education Excellence Award 2022",
    caption: "Osaka Educare awarded by WBR Corp, The National Education Excellence Award 2022 for Best Overseas Education Consultancy.",
    date: "25th Mar 2022",
    venue: "Delhi",
    image: "https://www.osakaair.com/files/award_achivement/image_file/15/2.jpeg",
  },
  {
    title: "National Excellence Award 2022",
    caption: "Osaka Connect Dot Com Pvt Ltd awarded National Excellence Award 2022 by WBR Corp.",
    date: "25th Mar 2022",
    venue: "",
    image: "https://www.osakaair.com/files/award_achivement/image_file/16/34.jpeg",
  },
  {
    title: "TATA AIG Insurance Top Seller - Kerala",
    caption: "Recognized as TATA AIG Insurance Top Seller in Kerala.",
    date: "1st Feb 2022",
    venue: "Kerala",
    image: "https://www.osakaair.com/files/award_achivement/image_file/18/AIG.JPG",
  },
  {
    title: "World Signature Award 2019",
    caption: "Osaka Air Travels received World Signature Award 2019 for the Most Prominent Brand of the Year.",
    date: "18th Jan 2020",
    venue: "Holiday Inn, Goa",
    image: "https://www.osakaair.com/files/award_achivement/image_file/5/signatureaward.jpg",
  },
  {
    title: "Indian Glory Award 2020",
    caption: "Dr. P. B. Boss received Indian Glory Awards for Leading Overseas Education Consultancy.",
    date: "10th Jan 2020",
    venue: "Arya Auditorium, New Delhi",
    image: "https://www.osakaair.com/files/award_achivement/image_file/11/indiangloryaward.jpg",
  },
  {
    title: "Business Connect Best Entrepreneur Award",
    caption: "Dr. P. B. Boss, Founder & Chairman, received Business Connect Best Entrepreneur Award.",
    date: "15th Nov 2019",
    venue: "",
    image: "https://www.osakaair.com/files/award_achivement/image_file/12/businessconnect.jpg",
  },
  {
    title: "Entrepreneur in Focus 2019",
    caption: "Featured in Business Connect, Entrepreneur in Focus 2019 for Osaka Connect's industry impact.",
    date: "4th Oct 2019",
    venue: "",
    image: "https://www.osakaair.com/files/award_achivement/image_file/9/entreprenur_award.jpg",
  },
];

export const MILESTONES = [
  { year: "1993", title: "Osaka Air Travels Founded", description: "Dr. P.B. Boss establishes Osaka Air Travels in Kerala, beginning a journey in travel services." },
  { year: "1997", title: "IATA Approved Agent", description: "Received IATA accreditation, marking a significant milestone in industry recognition and trust." },
  { year: "1998", title: "Osaka Air Travels Pvt. Ltd. Founded", description: "Incorporated as a private limited company, strengthening corporate governance and capabilities." },
  { year: "1999", title: "FFMC License from RBI", description: "Obtained Full Fledged Money Changers License from Reserve Bank of India, expanding into forex services." },
  { year: "2006", title: "Manpower Recruitment License", description: "Secured Manpower Recruitment License from the Ministry of External Affairs, diversifying service offerings." },
  { year: "2008", title: "Osaka Bhavan Established", description: "Inaugurated new office — Osaka Bhavan & Jeeva Pranava Wellness Kendra, marking physical expansion." },
  { year: "2010", title: "Kerala Tour Mart Founded", description: "Kerala Tour Mart India Pvt. Ltd. was founded, entering the inbound tourism segment." },
  { year: "2012", title: "Kochi Branch Opened", description: "Expanded to Kochi with a branch at M.G. Road, one of the city's prime commercial hubs." },
  { year: "2018", title: "Osaka Connect Launched", description: "Global B2B Portal OsakaConnect.com was founded, revolutionizing digital travel distribution." },
  { year: "2018", title: "Osaka Educare Founded", description: "Launched Global Educational Consultancy Osaka Educare, venturing into study abroad services." },
  { year: "2019", title: "Kerala's Biggest Travel Office", description: "Osaka Group launched Kerala's biggest travel management office space, setting a new benchmark." },
  { year: "2019", title: "New Head Office — Angamaly", description: "Relocated headquarters to KSRTC Building Complex, Angamaly — a modern, state-of-the-art facility." },
  { year: "2020", title: "Osaka Educare Relaunched", description: "Global Educational Consultancy Osaka Educare relaunched with expanded university partnerships." },
  { year: "2021", title: "Pan-India Expansion", description: "Launched branches in Bengaluru, Mumbai, Delhi & Chennai — establishing a true pan-India presence." },
  { year: "2023", title: "Dual IATA Accreditation", description: "Osaka Connect received independent IATA approval, making Osaka Group a rare dual-IATA accredited entity." },
  { year: "2023", title: "PATA Membership", description: "Osaka Connect became a PATA (Pacific Asia Travel Association) member, strengthening global alliances." },
];


export const CAREER_POSITIONS = [
  {
    id: 1,
    title: "Senior Travel Consultant",
    location: "Kochi",
    type: "Full-time",
    experience: "3-5 years",
  },
  {
    id: 2,
    title: "Visa Processing Executive",
    location: "Mumbai",
    type: "Full-time",
    experience: "1-3 years",
  },
  {
    id: 3,
    title: "Corporate Sales Manager",
    location: "Delhi",
    type: "Full-time",
    experience: "5+ years",
  },
  {
    id: 4,
    title: "Digital Marketing Specialist",
    location: "Angamaly (HQ)",
    type: "Full-time",
    experience: "2-4 years",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1769834628918-693863b58f68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBhaXJwbGFuZSUyMHRha2luZyUyMG9mZiUyMHJ1bndheSUyMGRyYW1hdGljJTIwc2t5fGVufDB8fHx8MTc3NDE3NjIyOXww&ixlib=rb-4.1.0&q=85",
  corporateTravel: "https://images.pexels.com/photos/5405597/pexels-photo-5405597.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  studyAbroad: "https://images.pexels.com/photos/6684600/pexels-photo-6684600.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  dubai: "https://images.pexels.com/photos/837908/pexels-photo-837908.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  beach: "https://images.pexels.com/photos/4784329/pexels-photo-4784329.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  airport: "https://images.unsplash.com/photo-1597245480778-915a20534323?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhaXJwbGFuZSUyMHdpbmRvdyUyMHZpZXclMjBzdW5zZXQlMjBhZXJpYWx8ZW58MHx8fHwxNzc0MTc2MjE4fDA&ixlib=rb-4.1.0&q=85",
  visa: "https://images.pexels.com/photos/4922356/pexels-photo-4922356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  globalMap: "https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  {
    label: "About",
    href: "/about",
    children: [
      { label: "Our Story", href: "/about" },
      { label: "Chairman's Message", href: "/chairman-message" },
      { label: "Leadership Team", href: "/leadership" },
    ],
  },
  {
    label: "Companies",
    href: "/companies",
  },
  {
    label: "Services",
    href: "/services",
    children: [
      { label: "Visa & Passport", href: "/services#visa" },
      { label: "Air Tickets", href: "/services#tickets" },
      { label: "Forex Services", href: "/services#forex" },
      { label: "Tour Packages", href: "/services#tours" },
      { label: "Study Abroad", href: "/services#study" },
      { label: "Corporate Travel", href: "/services#corporate" },
    ],
  },
  { label: "Global Presence", href: "/global-presence" },
  { label: "Awards", href: "/awards" },
  { label: "Careers", href: "/careers" },
  { label: "News", href: "/news" },
  { label: "Contact", href: "/contact" },
];
